import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { onlineTourDetailHotel } from '../api';
import { IOnlineTourHotelResult } from '../utils/types';
import { HotelCard } from './HotelCard';

type OnlineTourDetailHotelsProps = {
  tourId: number;
};

export default function OnlineTourDetailHotels({
  tourId,
}: OnlineTourDetailHotelsProps) {
  const { t } = useTranslation();
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState<boolean>(true);
  const [onlineTourDetailHotelResult, setOnlineTourDetailHotelResult] =
    useState<IOnlineTourHotelResult[]>([]);

  useEffect(() => {
    fetchOnlineTourDetailHotels(tourId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tourId]);

  const fetchOnlineTourDetailHotels = async (tourId: number) => {
    try {
      const res = await onlineTourDetailHotel(tourId);
      const data = await res.json();
      if (res?.status === 200) {
        setOnlineTourDetailHotelResult(data);
      } else {
        throw data;
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      setError(e.detail || t('loginPage.registerErrorMessage'));
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Grid container spacing={2}>
        {onlineTourDetailHotelResult.map(
          (res: IOnlineTourHotelResult, index: number) => (
            <Grid item xs={12} sm={6} md={4} xl={4} key={index}>
              <Typography variant="h6" sx={{ my: 2 }}>
                {res.cityName}
              </Typography>
              <HotelCard
                accommodationStayId={res.accommodationStayId}
                name={res.stayName}
                imageUrl={res.image}
                stars={res.star}
                stayNight={res.stayNight}
                stayDays={res.stayNight + 1}
                startDate={res.startDate}
                endDate={res.endDate}
                webSite={res.webSite}
                latitude={res?.latitude ? res.latitude.toString() : undefined}
                longitude={
                  res?.longitude ? res.longitude.toString() : undefined
                }
              />
            </Grid>
          ),
        )}
      </Grid>
    </Box>
  );
}
